module.exports = __webpack_public_path__ + "media/images/thumb_overlay-ac4f01230b71dbd3bcaa6c34b1b85020.png";